module.exports = __webpack_public_path__ + "img/9788925558974.76707c41.jpg";